// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__y5v6W","log":"ModalInventoryLogs_log__ZG-px","date":"ModalInventoryLogs_date__25yUd","userName":"ModalInventoryLogs_userName__sdV-g"};